import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getGuestMisconductFormData } from 'modules/accommodations/features/reservations/api';

export const useQueryGuestMisconductFormData = ({ enabled = true }: { enabled?: boolean }) => {
  return useQuery(QUERY_KEYS.GUEST_MISCONDUCT_FORM_DATA, getGuestMisconductFormData, {
    enabled,
  });
};
